import { Box, Breadcrumbs as MUIBreadcrumbs, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { SidebarMenuRoute, SidebarMenuRoutes } from "routes/sidebar";

const flattenObject = (
  sidebarMenuRoutes: Array<SidebarMenuRoute> | undefined
) => {
  let result: Array<SidebarMenuRoute> = [];
  sidebarMenuRoutes?.forEach((item) => {
    result = result.concat(item);
    const children = flattenObject(item?.children);
    result = result.concat(children);
  });
  return result;
};
interface Props {
  rightComponent?: React.ReactNode;
}
export const Breadcrumbs = (props: Props) => {
  const { rightComponent } = props;
  const location = useLocation();
  const pathSidebar = flattenObject(SidebarMenuRoutes).reverse();
  const breadcrumbs = pathSidebar.find((e) => {
    let finalPath: string | undefined;
    if (e.path?.includes("/edit")) {
      finalPath = e.path?.slice(0, e.path.indexOf("/edit") + 5);
    } else {
      finalPath = e.path;
    }
    return location.pathname.includes(finalPath ?? "***");
  });

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        height: "40px",
        marginBottom: "28px",
      }}
    >
      <MUIBreadcrumbs aria-label="breadcrumb">
        <Typography
          sx={{
            fontSize: "30px",
            fontWeight: "600",
          }}
          color="text.primary"
        >
          {breadcrumbs?.title}
        </Typography>
      </MUIBreadcrumbs>
      <Box sx={{ alignSelf: "center" }}>{rightComponent ?? null}</Box>
    </Box>
  );
};
